import React from 'react';
import { connect } from 'react-redux'
import { makeContractsByKennitala, getDescriptiveContractName, formatKennitala } from '../../utils'
// import ContractsOverviewDetailedContractInfo from '../contracts-overview-detailed-contract-info'
import { CONTRACT_STATUS_ACTIVE, CONTRACT_STATUS_WAITING } from '../../constants'
// import { SvgArrowIcon, SvgCheckIcon } from '../svg';
import { getFundTable } from '../../api/fund-table/actions'
import VIDPercentage from '../vid-percentage'
import VIDTermination from '../vid-termination'

import { createVidPartialContract, createVidtPartialContract } from '../../api/vid-percentage/actions'

import Alert from 'react-bootstrap/Alert';
import LinkButton from '../link-button';

let defaultFilter = (f) => f.IsMutualInsurance === "0" || f.Name==="Ótilgreint"

class AddPercentage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            multIds: {},
            status: "init",
            signing: {},
            contracts: {},
        }

        this.getFunds = this.getFunds.bind(this)
        this.getFieldValue = this.getFieldValue.bind(this)
        this.onCheckboxChange = this.onCheckboxChange.bind(this)
        this.validateButtonDisplay = this.validateButtonDisplay.bind(this)
        this.createDocument = this.createDocument.bind(this)
        this.onChangeCallback = this.onChangeCallback.bind(this)
        this.values = this.values.bind(this)
        this.addToContract = this.addToContract.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(getFundTable());
        
    }

    getCustNameAndKennitala(kennitala) {
        let ktNamePair = Object.entries(this.props.customers.peopleByKennitala).filter(item => item.includes(kennitala))
        let kt = ktNamePair[0][0]
        let name = ktNamePair[0][1]
        return (
            <div className="customer-container">
                <div className="customer">
                    <p>{name}</p>
                    <span>{formatKennitala(kt)}</span>
                </div>
            </div>)
    }

    // Add key, value pairs under state.contracts[contractId]
    addToContract(key, value, contractId){
        let state = {...this.state}
        if (!Object.keys(this.state.contracts).includes(contractId)) {
            state.contracts[contractId] = {
                [key]: value
            }
        } else {
            state.contracts[contractId][key] = value
        }
        this.setState(state)
    }

    onChangeCallback(e, infoType, contractId){
        let fundTable = this.props.fundTable
        const { name, value } = e.currentTarget;
        this.addToContract(name, value, contractId)
       
        if (name.includes("formerFund") || name.includes("otherFund") ) {
            let fund = fundTable.data.FundTable.FundLine.find((fund) => fund.FundId === value)
            let fundName = fund.Name;
            let fundNameName = `${name}Name`
            this.addToContract(fundNameName, fundName, contractId)
        }
    }

    onCheckboxChange(e, type, contractId) {
        const { name, checked } = e.currentTarget;
        this.addToContract(name, checked, contractId)
    }

    getFunds(contractId, customerId, formerFund, infoType, filter = defaultFilter) {
        let fundTable = this.props.fundTable
        let allFunds = <select className="custom-select col-12 col-sm-6" id={formerFund ? `vid-former-fund-${customerId}` : `vid-other-fund-${customerId}`} name={formerFund ? "VIDformerFund" : "VIDotherFund"} onChange={(e) => this.onChangeCallback(e, 'fund', contractId)} >
            {fundTable.data && !fundTable.isFetching && fundTable.data.FundTable.FundLine.filter(filter).map((fund) => {
                return (<option value={fund.FundId}>{fund.Name}</option>)
            })}
        </select>
        return allFunds
    }

    // Only used in percentage (only VID)
    validateButtonDisplay(type, contractId, contractType) {
        let val = this.values(contractId)
        if (type == "termination") {
            return val[contractType + "formerFund"] !== "000" && (val[contractType + "fundTransfer"] || val[contractType + "fundTermination"] || val[contractType + "fundTransferCancellation"] )
        }
        if (type == "split-percentage") {
            if (val[contractType + "otherFund"] !== "000") {
                return val[contractType + "allianzEmployerContribution"] !== "" &&
                    val[contractType + "otherEmployerContribution"] !== "" &&
                    val[contractType + "otherOwnContribution"] !== ""

            } else if (val[contractType + "otherFund"] === "000") {
                return val[contractType + "allianzEmployerContribution"] !== "" &&
                    (val[contractType + "otherOwnContribution"] === "0.0" || val[contractType + "otherOwnContribution"] === "" || val[contractType + "otherOwnContribution"] === "0") &&
                    (val[contractType + "otherEmployerContribution"] === "" || val[contractType + "otherEmployerContribution"] === "0.0" || val[contractType + "otherEmployerContribution"] === "0")
            } else {
                return val[contractType + "allianzEmployerContribution"] !== ""
            }

        }
        return false
    }

    values(contractId) {
        if (Object.keys(this.state.contracts).includes(contractId)) {
            return this.state.contracts[contractId]
        } else {
            return {}
        }
    }


    getFieldValue(fieldName, customerId) {
        return this.state[fieldName];
    }

    createDocument(e, customerId, axId, type = 'VID') {
        let val = this.values(axId)
        let paperSigning = false

        let vidData = {
            data: {
                [customerId]: {
                    [type]: {
                        [`${type}formerFund`]: val[type + "formerFund"],
                        [`${type}formerFundName`]: val[type + "formerFundName"],
                        [`${type}fundTransfer`]: val[type + "fundTransfer"],
                        [`${type}fundTermination`]: val[type + "fundTermination"],
                        [`${type}fundTransferCancellation`]: val[type + "fundTransferCancellation"],
                        [`${type}allianzOwnContribution`]: val[type + "allianzOwnContribution"],
                        [`${type}allianzEmployerContribution`]: val[type + "allianzEmployerContribution"],
                        [`${type}otherFund`]: val[type + "otherFund"],
                        [`${type}otherFundName`]: val[type + "otherFundName"],
                        [`${type}otherOwnContribution`]: val[type + "otherOwnContribution"],
                        [`${type}otherEmployerContribution`]: val[type + "otherEmployerContribution"],
                    }
                }
            },
            groups: {
                [customerId]: {
                    [type]: {
                        [type]: {
                            termination: {
                                [`${type}formerFund`]: val[type + "formerFund"],
                                [`${type}formerFundName`]: val[type + "formerFundName"],
                                [`${type}fundTransfer`]: val[type + "fundTransfer"],
                                [`${type}fundTermination`]: val[type + "fundTermination"],
                                [`${type}fundTransferCancellation`]: val[type + "fundTransferCancellation"],
                            },
                            'split-percentage': {
                                [`${type}allianzOwnContribution`]: val[type + "allianzOwnContribution"],
                                [`${type}allianzEmployerContribution`]: val[type + "allianzEmployerContribution"],
                                [`${type}otherOwnContribution`]: val[type + "otherOwnContribution"],
                                [`${type}otherEmployerContribution`]: val[type + "otherEmployerContribution"],
                                [`${type}otherFund`]: val[type + "otherFund"],
                                [`${type}otherFundName`]: val[type + "otherFundName"],
                            }
                        }
                    }
                }
            }
        }

        let data = Object.assign({}, this.props.offers)
        data = Object.assign(data, this.props.customers)
        data.infoCollection = this.props.infoCollection
        data.healthQuestions = vidData
        data.nationalRegistry = this.props.nationalRegistry
        data.euro_value = this.props.gui.currency
        data.payers = this.props.payers
        data.employers = this.props.employers
        data.insuranceTakers = this.props.insuranceTakers
        data.paperSigning = paperSigning
        data.termination = this.validateButtonDisplay("termination", axId, "VID")
        data.cancellation = vidData.data[customerId][`${type}fundTransferCancellation`] = val[type + "fundTransferCancellation"]
        data.split = this.validateButtonDisplay("split-percentage", axId, "VID")
        data.customerId = customerId
        data.axId = axId
        data.type = type

        if (type == "VID"){
            Promise.resolve(this.props.dispatch(createVidPartialContract(data)))
                .then(d => {
                    if (d.status !== "error") {
                        this.setState({ status: "done", signing: d })
                    }
                })
        } else if (type == "VIDT"){
            Promise.resolve(this.props.dispatch(createVidtPartialContract(data)))
                .then(d => {
                    if (d.status !== "error") {
                        this.setState({ status: "done", signing: d })
                    }
                })
        }
    }

    render() {
        let { customers, fundTable } = this.props;
        let contract_status_const = CONTRACT_STATUS_ACTIVE.concat(CONTRACT_STATUS_WAITING)
        

        return (
            <>
                <div className="row">
                    {customers.customerList.map((customer) => {
                        this.state.multIds[customer.Customer.AccountNum] = []
                        let allContracts =
                            <div className="add-id-container" id="accordion">
                                {Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
                                    return (
                                        <>
                                            {this.getCustNameAndKennitala(key)}
                                            <b>Samningar:</b>
                                            {Object.values(value).map((contract) =>
                                                <>
                                                    {contract.map(c => {
                                                        let customerId = c.CustAccount;
                                                        let val = this.values(c.ContractId)
                                                        let active_or_waiting = contract_status_const.includes(c.ContractStatusId)
                                                        if (c.ContractType === 'VID' && active_or_waiting) {
                                                            if (!this.state.multIds[customer.Customer.AccountNum].includes(c.ContractId)) {
                                                                this.state.multIds[customer.Customer.AccountNum].push(c.ContractId)
                                                            }
                                                            return (
                                                                <>
                                                                    <div>
                                                                        <div className="contract-type">{getDescriptiveContractName(c.ContractType)} - Samningur númer {c.ContractId}</div>
                                                                    </div>
                                                                    <div className="row justify-content-center xs-pt-10">
                                                                        <div className="col-12 px-0">
                                                                            <div className="row justify-content-center xs-pt-10 step">
                                                                                <div className="w-100 tab-content">
                                                                                    <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show vid-module">
                                                                                        <div className="accordion">
                                                                                            <VIDTermination
                                                                                                customerId={customerId}
                                                                                                contractId={c.ContractId}
                                                                                                type={c.ContractType}
                                                                                                fundTable={fundTable}
                                                                                                onCheckboxChange={this.onCheckboxChange}
                                                                                                onChange={this.onChangeCallback}
                                                                                                addToContract={this.addToContract}
                                                                                                values={this.values(c.ContractId)}
                                                                                                enableTransferCancellation={true}
                                                                                                />
                                                                                        </div>
                                                                                        <div className="accordion">
                                                                                            <VIDPercentage
                                                                                                type={c.ContractType}
                                                                                                heading="Bæta við prósentubreytingu"
                                                                                                customerId={customerId}
                                                                                                contractId={c.ContractId}
                                                                                                fundTable={fundTable}
                                                                                                VIDallianzOwnContribution={val["VIDallianzOwnContribution"]}
                                                                                                VIDotherOwnContribution={val["VIDotherOwnContribution"]}
                                                                                                validateButtonDisplay={this.validateButtonDisplay}
                                                                                                values={this.values(c.ContractId)}
                                                                                                getFunds={this.getFunds}
                                                                                                onChange={this.onChangeCallback}
                                                                                                addToContract={this.addToContract}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-12 text-center button-container">
                                                                                            {this.props.VIDPartialContract.data === null && <button className="btn btn-primary" disabled={!this.validateButtonDisplay("termination", c.ContractId, c.ContractType) && !this.validateButtonDisplay("split-percentage", c.ContractId, c.ContractType)} onClick={(e) => this.createDocument(e, customerId, c.ContractId)}>{this.props.VIDPartialContract.isFetching === true && <i className="fa fa-spin fa-sync-alt xs-ml-10" />} Stofna skjal til undirritunar</button>}
                                                                                            {this.props.VIDPartialContract.data !== null && this.props.VIDPartialContract.data.status === "success" && <LinkButton className="btn btn-primary" to={location => `/sign/${this.props.VIDPartialContract.data.signing_url}`} >Hefja undirritun</LinkButton>}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                        if (c.ContractType === 'VIDT' && active_or_waiting) {
                                                            if (!this.state.multIds[customer.Customer.AccountNum].includes(c.ContractId)) {
                                                                this.state.multIds[customer.Customer.AccountNum].push(c.ContractId)
                                                            }
                                                            return (
                                                                <>
                                                                    <div>
                                                                        <div className="contract-type">{getDescriptiveContractName(c.ContractType)} - Samningur númer {c.ContractId}</div>
                                                                    </div>
                                                                    <div className="row justify-content-center xs-pt-10">
                                                                        <div className="col-12 px-0">
                                                                            <div className="row justify-content-center xs-pt-10 step">
                                                                                <div className="w-100 tab-content">
                                                                                    <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show vid-module">
                                                                                        <div className="accordion">
                                                                                            <VIDTermination
                                                                                                customerId={customerId}
                                                                                                contractId={c.ContractId}
                                                                                                fundTable={fundTable}
                                                                                                getFieldValue={this.getFieldValue}
                                                                                                onCheckboxChange={this.onCheckboxChange}
                                                                                                type={c.ContractType}
                                                                                                onChange={this.onChangeCallback}
                                                                                                addToContract={this.addToContract}
                                                                                                values={this.values(c.ContractId)}
                                                                                                enableTransferCancellation={true}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-12 text-center button-container">
                                                                                            { this.props.VIDTPartialContract.data === null && 
                                                                                                <button className="btn btn-primary" disabled={!this.validateButtonDisplay("termination", c.ContractId, c.ContractType)} onClick={(e) => this.createDocument(e, customerId, c.ContractId, "VIDT")}>{this.props.VIDTPartialContract.isFetching === true && <i className="fa fa-spin fa-sync-alt xs-ml-10" />} Stofna skjal til undirritunar</button>}
                                                                                            { this.props.VIDTPartialContract.data !== null && this.props.VIDTPartialContract.data.status === "success" && <LinkButton className="btn btn-primary" to={location => `/sign/${this.props.VIDTPartialContract.data.signing_url}`} >Hefja undirritun</LinkButton>}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }

                                                    })}
                                                </>
                                            )}
                                            {!this.state.multIds[customer.Customer.AccountNum].length &&
                                                <Alert variant="warning">Þessi valmöguleiki á aðeins við viðskiptavini með Viðbótarlífeyrissparnað</Alert>
                                            }
                                        </>
                                    )
                                }
                                )}
                            </div>
                        return allContracts;
                    })}
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        brokers: {},
        insuranceTakers: {},
        payers: {},
        employers: {},
        fundTable: {},
        VIDPartialContract: {},
        VIDTPartialContract: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.brokers = (state.brokers === undefined) ? {} : state.brokers
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.employers = (state.employers === undefined) ? {} : state.employers
    f.fundTable = (state.fundTable === undefined) ? {} : state.fundTable
    f.VIDPartialContract = (state.VIDPartialContract === undefined) ? {} : state.VIDPartialContract
    f.VIDTPartialContract = (state.VIDTPartialContract === undefined) ? {} : state.VIDTPartialContract

    return f;
}

export default connect(mapStateToProps)(AddPercentage);